export { HorizontalShopifyMerchScroller } from './HorizontalShopifyMerchScroller'
